import {Title, TitleDownloadLink} from '@app/titles/models/title';
import {Episode} from '@app/titles/models/episode';
import {TitleBackdrop} from '@app/titles/title-poster/title-backdrop';
import {IconButton} from '@common/ui/buttons/icon-button';
import {useLocation} from 'react-router-dom';
import {Season} from '@app/titles/models/season';
import {useEffect, useState} from 'react';
import clsx from 'clsx';
// import {BASE_VIDEO_SRC} from '@common/http/query-client';
import VideoPlayer from './videoPlayerJs/VideoPlayer';
import {Modal} from '@mui/material';
import {TitlePageHeader} from './title-page-header';
import {useGetSingleWatch} from './requests/useGetSingleWatch';
import {WatchedType} from './requests/types';

interface QualityDetails {
  link: string;
  size: string;
  runtime: number;
}

interface QualityDetailsMovie {
  link: string;
  size: string;
  runtime: number;
  language: string;
}

interface EpisodeType {
  qualities: Record<string, QualityDetails>;
}

interface SeasonType {
  episodes: Record<string, EpisodeType>;
}

interface Series {
  seasons: Record<string, SeasonType>;
}

interface Movie {
  qualities: Record<string, Record<string, QualityDetailsMovie>>;
}

type GroupedSeriesData = Record<string, Series>;
type GroupedMovieData = Record<string, Movie>;

interface Props {
  domain?: string;
  title: Title;
  season?: Season;
  episode?: Episode;
  isLoggedIn?: boolean;
  epId?: number | string;
  isShow?: boolean;
}
export function TitlePageHeaderImage({
  domain,
  title,
  season,
  episode,
  isLoggedIn = false,
  epId,
  isShow,
}: Props) {
  const location = useLocation();
  const pathname = location.pathname;

  const [isShowTrailer, setIsShowTrailer] = useState<boolean>(false);

  const watchedTime = useGetSingleWatch(title.id);
  const watchData: WatchedType[] = watchedTime?.data?.data;

  const TEMP_DOMAIN = 'https://ols2.playerbni.info';

  const textAndNumbers = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
  ];
  const generateRandomString = () => {
    let result = '';
    for (let i = 0; i < 12; i++) {
      const randomIndex = Math.floor(Math.random() * textAndNumbers.length);
      result += textAndNumbers[randomIndex];
    }
    return result;
  };

  const groupSeriesData = (data: TitleDownloadLink[]): GroupedSeriesData => {
    if (pathname.includes('full-credits')) return {};

    const groupedData: GroupedSeriesData = {};

    data.forEach(item => {
      const {name, link, runtime, quality, size} = item;

      // Extract filename and clean it
      const filename = name.split('/').pop() || name;
      const cleanedName = filename
        .replace(/\.[^/.]+$/, '') // Remove extension
        .replace(/\./g, '_'); // Normalize underscores

      let seriesName = '';
      let season = 'S01';
      let episode = 'E01';

      // Match patterns like S01E01, S01_E01, S01-E02, etc.
      const match = cleanedName.match(
        /^(.*?)(?:_(S\d+))?[_\- ]*(?:E|EP?)?[_\- ]*(\d+).*$/i,
      );

      if (match) {
        seriesName = match[1].replace(/_/g, ' ').trim();
        season = match[2]
          ? `S${match[2].replace(/\D/g, '').padStart(2, '0')}`
          : 'S01';
        episode = `E${match[3].padStart(2, '0')}`;
      } else {
        // Fallback for names like "Series_01"
        const fallbackMatch = cleanedName.match(/(.*?)[_\- ](\d{1,2})$/i);
        if (fallbackMatch) {
          seriesName = fallbackMatch[1].replace(/_/g, ' ').trim();
          episode = `E${fallbackMatch[2].padStart(2, '0')}`;
        } else {
          seriesName = cleanedName.replace(/_/g, ' ').trim();
        }
      }

      // Initialize nested structure
      if (!groupedData[seriesName]) {
        groupedData[seriesName] = {seasons: {}};
      }
      if (!groupedData[seriesName].seasons[season]) {
        groupedData[seriesName].seasons[season] = {episodes: {}};
      }
      if (!groupedData[seriesName].seasons[season].episodes[episode]) {
        groupedData[seriesName].seasons[season].episodes[episode] = {
          qualities: {},
        };
      }

      if (item?.link.includes('mkv')) return;
      // Add quality details
      groupedData[seriesName].seasons[season].episodes[episode].qualities[
        quality
      ] = {
        // link: `${import.meta.env.VITE_BASE_VIDEO_SRC}${link}`,
        link: link.includes('Original_Language_Movies')
          ? `${TEMP_DOMAIN}/player${link}`
          : `${import.meta.env.VITE_BASE_VIDEO_SRC}${link}`,
        // link: `https://${generateRandomString()}.${item.domain?.target}/player${link}`,
        size,
        runtime,
      };
    });

    return groupedData;
  };

  // const groupMovieData = (data: TitleDownloadLink[]): GroupedMovieData => {
  //   if (pathname.includes('full-credits')) return {};

  //   const groupedData: GroupedMovieData = {};

  //   data.forEach(item => {
  //     const {link, runtime, quality, size} = item;

  //     if (!groupedData[title?.name?.replaceAll(' ', '_')]) {
  //       groupedData[title?.name?.replaceAll(' ', '_')] = {qualities: {}};
  //     }

  //     // groupedData[movieName].qualities[quality] = {
  //     //   // link: `${import.meta.env.VITE_BASE_VIDEO_SRC}${link}`,
  //     //   // link: link.includes('Original_Language_Movies')
  //     //   //   ? `${TEMP_DOMAIN}${link}`
  //     //   //   : `${import.meta.env.VITE_BASE_VIDEO_SRC}${link}`,
  //     //   link: `https://${generateRandomString()}.${item.target}/player${link}`,
  //     //   size,
  //     //   runtime,
  //     // };
  //     if (!title?.name) return;
  //     if (item?.link.includes("mkv")) return
  //     groupedData[title?.name?.replaceAll(' ', '_')].qualities[quality] = {
  //       // link: `${import.meta.env.VITE_BASE_VIDEO_SRC}${link}`,
  //       link: link.includes('Original_Language_Movies')
  //         ? `${TEMP_DOMAIN}${link}`
  //         : `${import.meta.env.VITE_BASE_VIDEO_SRC}${link}`,
  //       // link: `https://${generateRandomString()}.${item.domain?.target}/player${link}`,
  //       size,
  //       runtime,
  //     };
  //   });

  //   return groupedData;
  // };

  const groupMovieData = (data: TitleDownloadLink[]): GroupedMovieData => {
    if (pathname.includes('full-credits')) return {};

    const groupedData: GroupedMovieData = {};

    data.forEach(item => {
      const {link, runtime, quality, size, language} = item;

      if (!title?.name) return;
      if (item?.link.includes('mkv')) return;

      const movieName = title.name.replaceAll(' ', '_');

      if (!groupedData[movieName]) {
        groupedData[movieName] = {qualities: {}};
      }

      if (!groupedData[movieName].qualities[quality]) {
        groupedData[movieName].qualities[quality] = {};
      }

      groupedData[movieName].qualities[quality][language] = {
        link: link.includes('Original_Language_Movies')
          ? `${TEMP_DOMAIN}${link}`
          : `${import.meta.env.VITE_BASE_VIDEO_SRC}${link}`,
        size,
        runtime,
        language,
      };
    });

    return groupedData;
  };

  useEffect(() => {
    setIsShowTrailer(isShow as boolean);
  }, [isShow]);

  // if (!backdropUrl) {
  //   return null;
  // }

  const backdrop = (
    <TitleBackdrop
      title={title}
      episode={episode}
      size="w-full h-full max-md:!h-[450px]"
      className="object-top"
      lazy={false}
    />
  );

  const groupedData = title.is_series
    ? groupSeriesData(title.download_links)
    : groupMovieData(title.download_links);

  // console.log(groupedData);
  // console.log(epId);

  useEffect(() => {
    if (epId !== 0 && !!epId) {
      setIsShowTrailer(true);
    }
  }, [epId]);

  return (
    <header className="relative isolate max-h-500 overflow-hidden bg-black max-md:h-[500px] md:max-h-400 lg:max-h-[50rem]">
      <div className="relative left-0 right-0 top-0 z-20 mx-auto h-full w-full px-24">
        {!pathname.includes('full-credits') && (
          <div
            className={clsx(
              'relative flex-shrink-0',
              !isShowTrailer && 'hidden',
            )}
          ></div>
        )}
        <div className="absolute inset-y-0 left-0 z-10 w-1/4 bg-gradient-to-r from-black to-transparent"></div>

        <div className="absolute inset-y-0 right-0 z-10 w-1/4 bg-gradient-to-l from-black to-transparent"></div>
        {backdrop}
      </div>
      <TitlePageHeader
        title={title}
        showPoster={
          pathname.includes('full-credits') ||
          pathname.includes('images') ||
          pathname.includes('primary')
        }
      />
      {!isShowTrailer && (
        <div className="h-[calc(100% + 20px)] absolute left-1/2 top-1/2 z-10 w-[calc(100%+100px)] -translate-x-1/2 -translate-y-1/2 bg-black opacity-50 blur-md">
          {backdrop}
        </div>
      )}
      <Modal
        open={isShowTrailer}
        onClose={e => {
          //@ts-expect-error
          e.stopPropagation();
          setIsShowTrailer(false);
        }}
        className="flex items-center justify-center"
      >
        <div className="absolute z-[4] h-screen !w-full bg-black">
          <VideoPlayer
            titleId={title.id}
            title={title.name}
            //@ts-expect-error
            data={groupedData}
            isSeries={title.is_series}
            trailerSrc={
              !isLoggedIn
                ? title.videos.filter(item => item.category === 'trailer')[0]
                : undefined
            }
            chosenPlay={epId as string}
            resumeData={watchData && watchData[0]}
            onExit={() => setIsShowTrailer(false)}
          />
        </div>
      </Modal>
      {isLoggedIn && title.download_links.length === 0 ? null : !isLoggedIn &&
        title.videos.filter(item => item.category === 'trailer').length ===
          0 ? null : pathname.includes('full-credits') ||
        pathname.includes('images') ||
        pathname.includes('primary') ? null : (
        <PlayButton onClick={() => setIsShowTrailer(true)} />
      )}
      <div className="pointer-events-none absolute left-0 top-0 z-30 h-full w-full bg-gradient-to-b from-black/20 md:from-black/40" />
    </header>
  );
}

interface PlayButtonProps {
  onClick: () => void;
}
function PlayButton({onClick}: PlayButtonProps) {
  return (
    <IconButton
      radius="rounded-full"
      // color="white"
      variant="text"
      size="lg"
      onClick={onClick}
      className="absolute inset-0 z-40 max-md:!m-0 max-md:!mx-auto max-md:!mb-auto max-md:!mt-90 md:m-auto"
    >
      <div className="col-lg-5 col-md-12 trailor-video iq-slider d-lg-block">
        <div className="video-open playbtn !flex !justify-center md:!items-center">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width="80px"
            height="80px"
            viewBox="0 0 213.7 213.7"
            enableBackground="new 0 0 213.7 213.7"
            xmlSpace="preserve"
          >
            <polygon
              className="triangle"
              fill="none"
              strokeWidth="7"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="73.5,62.5 148.5,105.8 73.5,149.1 "
            ></polygon>
            <circle
              className="circle"
              fill="none"
              strokeWidth="7"
              strokeLinecap="round"
              strokeLinejoin="round"
              cx="106.8"
              cy="106.8"
              r="103.3"
            ></circle>
          </svg>
        </div>
      </div>
    </IconButton>
  );
}
